import { IRefIds } from 'constants/refs';
import { BaseModel } from 'models/BaseModel';
import { get } from 'services/request';
import PublishRefModel from './PublishRefModel';

type IPublishResource = {
  ref: IRefIds;
  name: string;
  batch: number;
  enabled: boolean;
};

// Export flow of the Publish screen. Whether publishing is ALLOWED is decided by the
// Publish gate (usePublishGate in the component); this model only lists the resources
// and runs their exports sequentially.
export default class PublishModel extends BaseModel {
  resources: PublishRefModel[] = [];
  publishing = false;
  itemUpdated = []; //for displaying ItemLayout

  async getResources() {
    this.loadingItem = true;
    this.render();
    const resources = await get<IPublishResource[]>(`courses/${this.courseId}/publish-resources`);
    this.resources = (Array.isArray(resources) ? resources : [])
      .filter((resource) => resource.enabled)
      .map(
        (resource) =>
          new PublishRefModel({
            render: this.render,
            courseId: this.courseId,
            ref: resource.ref,
            name: resource.name,
            batch: resource.batch,
          }),
      );
    this.loadingItem = false;
    this.render();
  }

  async publish() {
    if (this.publishing) {
      return;
    }
    this.publishing = true;
    this.render();
    for (const resource of this.resources) {
      await resource.publish();
    }
    this.publishing = false;
    this.render();
  }
}
